import React, { useState, useEffect, useMemo } from 'react';
import { Container, InputField } from '@common';
import DataTableReact from '@common/datatable/DataTableReact.jsx';
import apiService from 'services/apiService';
import { Dots } from '../../assets/svg.js';
import { FaPlus } from 'react-icons/fa6';
import { Menu, MenuItem } from '@mui/material';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import CustomModal from '@common/CustomModal/CustomModal.js';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

function HospitalList() {
  const [hospitals, setHospitals] = useState([]);
  const [clusters, setClusters] = useState([]);
  const [editableHospital, setEditableHospital] = useState(null);
  const [openRowId, setOpenRowId] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteClusterId, setDeleteClusterId] = useState('');
  const [regions, setRegions] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setOpenRowId(rowId);
  };

  const toggle = () => setOpenForm(!openForm);

  const handleCloseTableModal = () => {
    setAnchorEl(null);
    setOpenRowId(null);
  };

  function handleDeleteCluster({ id, name, regionId, clusterId }) {
    apiService
      .delete(`site/${id}`, {
        name,
        cluster_id: clusterId,
        region_id: regionId,
      })
      .then((res) => {
        toast.success(res.message);

        fetchHospitals();
        setIsModalOpen(false);
        setDeleteClusterId('');
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log('Error Deleting Cluster', err);
      });
  }

  function handleCreateHospital(values) {
    apiService
      .post('site', {
        name: values.hospitalName,
        region_id: values.regionNameOption.value,
        cluster_id: values.clusterNameOption.value,
      })
      .then((res) => {
        toast.success(res.message);
        fetchHospitals();
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log('Error creating Cluster', err);
      });
  }

  function handleUpdateHospital(values) {
    apiService
      .put(`site/${editableHospital?.id}`, {
        name: values.hospitalName,
        region_id: values.regionNameOption.value,
        cluster_id: values.clusterNameOption.value,
      })
      .then((res) => {
        toast.success(res.message);
        fetchHospitals();
        setEditableHospital(null);
        setIsEdit(false);
      })
      .catch((err) => {
        toast.error(err.message);
        console.log('Error Updating Cluster', err);
      });
  }

  function handleHospitalSubmit(values, { resetForm }) {
    if (isEdit) {
      handleUpdateHospital(values);
    } else {
      handleCreateHospital(values);
    }
    setOpenForm(false);
    resetForm();
  }

  const columns = [
    {
      id: 'Region Name',
      header: 'Region Name',

      accessorFn: (row) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#0A0D14] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {row?.regionName}
          </span>
        );
      },
    },
    {
      id: 'Cluster Name',
      header: 'Cluster Name',

      accessorFn: (row) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#0A0D14] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {row?.clusterName}
          </span>
        );
      },
    },
    {
      id: 'Hospital Name',
      header: 'Hospital Name',

      accessorFn: (row) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#0A0D14] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {row?.hospitalName}
          </span>
        );
      },
    },
  ];
  const renderRowActions = ({ row, table }) => {
    const isOpen = openRowId === row.index;

    return (
      <>
        <div className="flex gap-3">
          <Dots
            className="action-icon cursor-pointer"
            onClick={(e) => handleClick(e, row?.index)}
          />
        </div>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={isOpen}
          onClose={handleCloseTableModal}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          sx={{
            boxShadow: 'none',
          }}
        >
          <MenuItem
            sx={{
              fontSize: '18px',
              padding: '1px 24px',
              minWidth: '150px',
              borderRadius: '16px',
              '&:hover': {
                backgroundColor: '#FFF',
              },
            }}
            onClick={(e) => {
              e.stopPropagation(); // Prevent parent div click event
              setIsEdit(true);
              setOpenForm(true);
              setEditableHospital({
                name: row?.original?.hospitalName,
                id: row?.original?.id,
                regionId: row?.original?.regionId,
                regionName: row?.original?.regionName,
                clusterName: row?.original?.clusterName,
                clusterId: row?.original?.clusterId,
              });
              handleCloseTableModal(); // Close menu properly
            }}
          >
            <div className="flex justify-between w-[100%]">
              {/* Edit Option */}
              <p
                className="self-center m-1 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent parent div click event
                  setIsEdit(true);
                  setOpenForm(true);
                  setEditableHospital({
                    name: row?.original?.hospitalName,
                    id: row?.original?.id,
                    regionId: row?.original?.regionId,
                    regionName: row?.original?.regionName,
                    clusterName: row?.original?.clusterName,
                    clusterId: row?.original?.clusterId,
                  });
                  handleCloseTableModal(); // Close menu properly
                }}
              >
                Edit
              </p>

              {/* Delete Option */}
            </div>
          </MenuItem>
          <MenuItem
            sx={{
              fontSize: '18px',
              padding: '1px 24px',
              minWidth: '150px',
              borderRadius: '16px',
              '&:hover': {
                backgroundColor: '#FFF',
              },
            }}
            onClick={(e) => {
              e.stopPropagation();
              setIsModalOpen(true);
              setDeleteClusterId({
                id: row?.original?.id,
                name: row?.original?.clusterName,
                regionId: row?.original?.regionId,
              });
              handleCloseTableModal();
            }}
          >
            <div className="flex justify-between w-[100%]">
              {/* Edit Option */}

              <p
                className="self-center m-1 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsModalOpen(true);
                  setDeleteClusterId({
                    id: row?.original?.id,
                    name: row?.original?.clusterName,
                    regionId: row?.original?.regionId,
                  });
                  handleCloseTableModal();
                }}
              >
                Delete
              </p>
              <p
                onClick={(e) => {
                  e.stopPropagation();
                  setIsModalOpen(true);
                  setDeleteClusterId({
                    id: row?.original?.id,
                    name: row?.original?.clusterName,
                    regionId: row?.original?.regionId,
                  });
                  handleCloseTableModal();
                }}
              ></p>

              {/* Delete Option */}
            </div>
          </MenuItem>
        </Menu>
      </>
    );
  };

  const handleRenderRowActions = ({ row, table }) =>
    renderRowActions({ row, table });

  const fetchHospitals = async (page, rowsPerPage) => {
    try {
      const { data } = await apiService.get(
        `site?is_pagination=true&per_page=${rowsPerPage}&page=${page}`
      );
      setTotalRows(data?.total);
      const hospitalsData = [];
      data?.data?.map(({ name, _id, region, cluster }) => {
        hospitalsData.push({
          hospitalName: name,
          id: _id,
          regionName: region?.name,
          regionId: region?._id,
          clusterName: cluster?.name,
          clusterId: cluster?._id,
        });
      });

      setHospitals([...hospitalsData]);
    } catch (e) {
      console.log('Error fetching Clusters:', e);
    }
  };

  function fetchRegions() {
    apiService
      .get('region')
      .then((res) => {
        const regionData = new Map();
        res.data.map(({ name, _id }) => {
          regionData.set(_id, { label: name, value: _id });
        });
        setRegions(regionData);
      })
      .catch((err) => {
        console.log('Error fetching Regions', err);
      });
  }

  function fetchClusters(region_id, setFieldValue, selectedOption) {
    apiService
      .get('cluster?region_id=' + region_id)
      .then((res) => {
        const clusterData = new Map();
        res.data.map(({ name, _id }) => {
          clusterData.set(_id, { label: name, value: _id });
        });
        setClusters(clusterData);
        setFieldValue('clusterName', Array.from(clusterData.values()));
        setFieldValue('regionNameOption', selectedOption);
      })
      .catch((err) => {
        console.log('Error fetching Clusters', err);
      });
  }

  const initialValues = useMemo(() => {
    return {
      hospitalName: editableHospital?.name ? editableHospital?.name : '',
      regionName: regions,
      clusterName: clusters,
      regionNameOption: isEdit ? regions.get(editableHospital?.regionId) : '',
      clusterNameOption: isEdit
        ? clusters.get(editableHospital?.clusterId)
        : '',
    };
  }, [regions, editableHospital, clusters, isEdit]);

  useEffect(() => {
    fetchHospitals(page, rowsPerPage);
    fetchRegions();
  }, [page, rowsPerPage, hospitals]);

  useEffect(() => {
    fetchClusters(initialValues.regionNameOption.value);
  }, [initialValues.regionNameOption]);

  const validationSchema = Yup.object({
    hospitalName: Yup.string().required('Cluster Name is required'),
    regionNameOption: Yup.object().required('Region is required'),
    clusterNameOption: Yup.object().required('Cluster is required'),
  });
  return (
    <Container>
      <div className="flex gap-2 mb-4">
        <h1>Hospitals</h1>
        <div
          className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-full transition-transform transform duration-200 
        hover:shadow-lg hover:scale-105 active:scale-95 cursor-pointer"
          onClick={() => setOpenForm(true)}
        >
          <FaPlus className="text-green-500 text-3xl" />
        </div>
      </div>
      <CustomModal
        isOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        title={'Delete Cluster'}
        bodyText={'Are you want to Delete this Cluster?'}
        buttonText={'Delete'}
        onClick={() => handleDeleteCluster(deleteClusterId)}
      />

      {openForm && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
            <Formik
              initialValues={initialValues}
              enableReinitialize={true}
              validationSchema={validationSchema}
              onSubmit={handleHospitalSubmit}
            >
              {({ values, errors, touched, setFieldValue, handleChange }) => (
                <ModalBody>
                  <Form>
                    <div className=" ">
                      <div>
                        <label>
                          Region Name
                          <span className="text-[#2D9F75]">*</span>
                        </label>

                        <Select
                          options={Array.from(values.regionName.values())}
                          value={values.regionNameOption}
                          onChange={(selectedOption) => {
                            fetchClusters(
                              selectedOption.value,
                              setFieldValue,
                              selectedOption
                            );
                          }}
                        />
                        {touched.regionNameOption &&
                          errors.regionNameOption && (
                            <div className="text-red-500 text-sm mt-1">
                              {errors.regionNameOption}
                            </div>
                          )}
                      </div>
                      <div>
                        <label>
                          Cluster Name
                          <span className="text-[#2D9F75]">*</span>
                        </label>

                        <Select
                          options={Array.from(values.clusterName.values())}
                          value={values.clusterNameOption}
                          onChange={(selectedOption) => {
                            setFieldValue('clusterNameOption', selectedOption);
                          }}
                        />
                        {touched.clusterNameOption &&
                          errors.clusterNameOption && (
                            <div className="text-red-500 text-sm mt-1">
                              {errors.clusterNameOption}
                            </div>
                          )}
                      </div>
                      <div>
                        <InputField
                          isRequiredClass="text-[#2D9F75]"
                          label="Hospital Name"
                          name="hospitalName"
                          isRequired={true}
                          height="h-[40px]"
                          value={values.hospitalName}
                          onChange={(e) => handleChange(e)}
                        />
                        {touched.hospitalName && errors.hospitalName && (
                          <div className="text-red-500 text-sm mt-1">
                            {errors.hospitalName}
                          </div>
                        )}
                      </div>
                      {/* <ModalFooter> */}
                      <div className="d-flex justify-content-end self-end gap-2 mt-4">
                        <Button color="success" type="submit">
                          {!isEdit ? 'Submit' : 'Update'}
                        </Button>
                        {/* {isEdit && ( */}
                        <Button
                          color="danger"
                          type="submit"
                          onClick={() => {
                            setOpenForm(false);
                            setIsEdit(false);
                            setEditableHospital(null);
                          }}
                        >
                          Cancel
                        </Button>
                        {/* )} */}
                      </div>
                      {/* </ModalFooter> */}
                    </div>
                  </Form>
                </ModalBody>
              )}
            </Formik>
          </div>
        </div>
      )}

      <DataTableReact
        data={hospitals}
        columns={columns}
        renderRowActions={handleRenderRowActions}
        setPage={setPage}
        page={page}
        setRowsPerPage={setRowsPerPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        shouldShowActions={true}
      />
    </Container>
  );
}

export default HospitalList;
